<template>

	<div class="form-group oddevencol">

		<div class="col-md-14 control-label" v-bind:class="{ withcomm : comment != null }">
			<label>
				{{ text }}
				<span class="public-data" title="Visas i klippkort" v-if="asterisk">*</span>
			</label>
			<p v-html="comment"></p>
		</div>

		<div class="col-md-36" v-if="type == 'text'">
			<input type="text" v-model="input" class="form-control">
		</div>

		<div class="col-md-36" v-if="type == 'textarea'">
			<textarea v-model="input" class="form-control"></textarea>
		</div>

	</div>

</template>

<script>

	export default {

		props: {

			type: {
				default: 'text'
			},
			model: {
				required: true
			},
			text: {
				required: true
			},
			asterisk: {
				default: false
			},
			comment: {
				default: ''
			}

		},


		data() {

			return {

				input: this.model,

				disableInputWatcher: false,

			}

		},

		watch: {

			input() {

				console.log('watch input trigger')

				if(this.disableInputWatcher == true) {

					console.log('watch is disabled, returning')

					this.disableInputWatcher = false
					return
				}

				console.log('input data watcher triggered')
				this.$emit('update:model', this.input)
			},
			model(val) {
				console.log('model watcher changed')
				console.log('new value')
				console.log(val)
				if(this.input != val) {
					this.disableInputWatcher = true
				}
				this.input = val
			}

		}


	}

</script>
